import { motion } from 'motion/react'
import { ScreenShell } from '@/components/layout/ScreenShell'
import { PixelIcon } from '@/components/ui/PixelIcon'
import { TITLE_LOGO } from '@/game/art'

const TECH = ['React Three Fiber', 'motion/react', 'Tone.js', 'Arcade Cloud']

const LINKS = [
  {
    href: 'https://tonyebrown.com',
    icon: 'user',
    title: 'Tonye Brown',
    note: 'Design, code, and the little glow itself. More about me.',
  },
  {
    href: 'https://github.com/canadianeagle/take-me-home',
    icon: 'gamepad',
    title: 'take-me-home on GitHub',
    note: 'The full source: slide engine, BFS solver, procedural generator.',
  },
]

export function CreditsScreen() {
  return (
    <ScreenShell title="Credits">
      <div className="flex flex-col gap-4">
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          className="rounded-[var(--r-lg)] bg-[var(--surface)] shadow-emboss border border-[var(--edge)]/40 p-5 text-center"
        >
          <img
            src={TITLE_LOGO}
            alt="Take Me Home"
            draggable={false}
            className="mx-auto mb-3 h-16 w-16 object-contain"
            style={{ filter: 'drop-shadow(0 0 18px #ffb45455)' }}
          />
          <h2 className="font-display text-lg font-black">Take Me Home</h2>
          <p className="mt-1 text-sm text-[var(--text-dim)]">
            A cozy momentum puzzle about a small light finding its way home.
          </p>
        </motion.div>

        {LINKS.map((l, i) => (
          <motion.a
            key={l.href}
            href={l.href}
            target="_blank"
            rel="noreferrer"
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.08 * (i + 1) }}
            whileTap={{ scale: 0.98 }}
            className="flex items-center gap-3 rounded-[var(--r-md)] bg-[var(--surface)] shadow-emboss border border-[var(--edge)]/30 p-4 hover:border-[var(--ember)]/50 transition"
          >
            <span className="grid h-11 w-11 shrink-0 place-items-center rounded-[var(--r-sm)] bg-[var(--surface-raised)] shadow-emboss">
              <PixelIcon name={l.icon} size={20} />
            </span>
            <div className="min-w-0">
              <div className="font-display font-bold">{l.title}</div>
              <p className="text-xs text-[var(--text-faint)]">{l.note}</p>
            </div>
            <span className="ml-auto text-[var(--text-faint)]">
              <PixelIcon name="continue" size={16} />
            </span>
          </motion.a>
        ))}

        <div className="rounded-[var(--r-md)] bg-[var(--surface-sunken)] p-4">
          <p className="mb-2 text-center text-xs font-semibold text-[var(--text-faint)]">Built with</p>
          <div className="flex flex-wrap justify-center gap-1.5">
            {TECH.map((t) => (
              <span key={t} className="rounded-full bg-[var(--surface-raised)] px-2.5 py-1 text-[11px] font-bold text-[var(--text-dim)] shadow-emboss">
                {t}
              </span>
            ))}
          </div>
        </div>
      </div>
    </ScreenShell>
  )
}
